export { EventSchema as GetEventSchema } from '@src/entities/Event/includes/schemas';
